import { Box } from '@mui/material';
import BrandHeading from '../../../components/Page/BrandHeading';
import RelatedCategories from '../../Categories/components/RelatedCategories';
import { useTranslation } from 'react-i18next';
import Article from '../../../types/Article';
import RelatedArticlesSection from './RelatedArticlesSection';
import { useCallback } from 'react';
import { getPrimaryCategories } from '../../../utilities/Categories';
import { CONTENT_TYPE, ContentType } from '../types/types';
import RelatedNewsSection from './RelatedNewsSection';

interface ArticleFooterAreaProps {
  article: Article;
}

export default function ArticleFooterArea({
  article,
}: Readonly<ArticleFooterAreaProps>) {
  const { t } = useTranslation();
  const hasCategories = article.meta.allCategories().length > 0;
  const contentTypeHasCategory = useCallback(
    (contentType?: ContentType) => {
      return getPrimaryCategories(contentType).includes(
        article.meta.categories.primary,
      );
    },
    [article.meta.categories.primary],
  );

  return (
    <>
      {contentTypeHasCategory(CONTENT_TYPE.LegalNews) && (
        <FooterSection
          title={t('article.latestNewsOnTopic', {
            topic: article.meta.categories.primary,
          })}
        >
          <RelatedNewsSection
            primaryCategory={article.meta.categories.primary}
          />
        </FooterSection>
      )}
      {contentTypeHasCategory() && (
        <FooterSection
          title={t('article.latestContentOnTopic', {
            topic: article.meta.categories.primary,
          })}
        >
          <RelatedArticlesSection
            primaryCategory={article.meta.categories.primary}
          />
        </FooterSection>
      )}
      {hasCategories && (
        <FooterSection title={t('article.moreContent')}>
          <Box
            sx={{
              paddingBottom: 3,
            }}
          >
            <RelatedCategories categories={article.meta.allCategories()} />
          </Box>
        </FooterSection>
      )}
    </>
  );
}

interface FooterSectionProps {
  title: string;
  children: React.ReactNode;
}

function FooterSection({ title, children }: Readonly<FooterSectionProps>) {
  return (
    <>
      <BrandHeading variant='h2' component='h2' marginTop={6} marginBottom={3}>
        {title}
      </BrandHeading>
      {children}
    </>
  );
}
